module.exports = __webpack_public_path__ + "static/media/background_4.44d5ff78.jpg";